import React from 'react';
import * as ReactDOM from 'react-dom/client';

import './GlsDpm.css'; 

class XGLSDPMPARCELLOCKER extends HTMLElement {
    connectedCallback() {
        const mountPoint = document.createElement('div');
        this.attachShadow({ mode: 'open' }).appendChild(mountPoint);

        const root = ReactDOM.createRoot(mountPoint);
 
        const style = {
            display: 'inline-block',
            width: '100%',  
            height: '600px',
        }

        // filter type lehet: parcel-locker (automata) vagy parcel-shop (csomagpont)
        root.render(<gls-dpm filter-type="parcel-locker" country="hu" id="gls-dpm-map" style={style} />);
   
        setTimeout(() => {
            this.shadowRoot.getElementById('gls-dpm-map').addEventListener("change", e => {
                GlsDpm.handle_map_change(e);
            });
        }, 1000);
       
    }
}

class XGLSDPMPARCELSHOP extends HTMLElement {
    connectedCallback() {
        const mountPoint = document.createElement('div');
        this.attachShadow({ mode: 'open' }).appendChild(mountPoint);

        const root = ReactDOM.createRoot(mountPoint);
 
        const style = {
            display: 'inline-block',
            width: '100%',  
            height: '600px',
        }

        // filter type lehet: parcel-locker (automata) vagy parcel-shop (csomagpont)
        root.render(<gls-dpm filter-type="parcel-shop" country="hu" id="gls-dpm-map" style={style} />);
   
        setTimeout(() => {
            this.shadowRoot.getElementById('gls-dpm-map').addEventListener("change", e => {
                GlsDpm.handle_map_change(e);
            });
        }, 1000);
       
    }
}

class GlsDpm extends React.Component {

    static mapData = {
        select_gls_pcl_shop_id: '',
        select_gls_shop_code: '',
        select_gls_pcl_shop_name: '',

        select_gls_pcl_shop_zipcode: '',
        select_gls_pcl_shop_city: '',
        select_gls_pcl_shop_address: '',
        select_gls_pcl_shop_email: '',
        select_gls_pcl_shop_phone: '',
    }

    constructor(props) {
        super(props);
        
        this.state = {
            show: props.show,
            filter_type: props.filter_type,
        };
    }

    static handle_map_change(e)
    {
        if (!!e.detail && !!e.detail.id) 
        {
            const data = e.detail;

            this.mapData.select_gls_pcl_shop_id = data.id;
            this.mapData.select_gls_shop_code = data.id;
            this.mapData.select_gls_pcl_shop_name = data.name;

            if (typeof data.contact != 'undefined') 
            {
                this.mapData.select_gls_pcl_shop_zipcode = typeof data.contact.postalCode != 'undefined' ? data.contact.postalCode : '';
                this.mapData.select_gls_pcl_shop_city = typeof data.contact.city != 'undefined' ? data.contact.city : '';
                this.mapData.select_gls_pcl_shop_address = typeof data.contact.address != 'undefined' ? data.contact.address : '';
                this.mapData.select_gls_pcl_shop_email = typeof data.contact.email != 'undefined' ? data.contact.email : '';
                this.mapData.select_gls_pcl_shop_phone = typeof data.contact.phone != 'undefined' ? data.contact.phone : '';
            }

            window.modals.CheckoutDeliveryRef.current.handle_gls_map_data_change(this.mapData);
        }
    }

    componentDidMount() {
        this.create_web_component();
    }

    create_web_component() {
        const { show, filter_type } = this.state;

        if (typeof window.AppRef.current.third_party['gls-dpm'] == 'undefined')
        {
            window.AppRef.current.third_party['gls-dpm'] = {};
        }
    
        if (typeof window.AppRef.current.third_party['gls-dpm'][filter_type] == 'undefined')
        {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = process.env.REACT_APP_PUBLIC_URL + 'ext/gls-dpm/gls-dpm.js';
            script.onload = () => {
                window.AppRef.current.third_party['gls-dpm'][filter_type] = true;

                if (filter_type == 'parcel-locker')
                {
                    customElements.get('x-gls-dpm-'+filter_type) || customElements.define('x-gls-dpm-'+filter_type, XGLSDPMPARCELLOCKER); 
                }
                else {
                    customElements.get('x-gls-dpm-'+filter_type) || customElements.define('x-gls-dpm-'+filter_type, XGLSDPMPARCELSHOP); 
                }
            };

            document.head.appendChild(script);
        }
    }

    render() { 
        const { show, filter_type } = this.state;

        if (!show) return ''; 
        
        return <div id="select_gls_chooser">{filter_type == 'parcel-shop' ? <x-gls-dpm-parcel-shop /> : <x-gls-dpm-parcel-locker />}</div>;
    }
}
 
export default GlsDpm;